import SCTranslations from "../../../components/simpleCrud/SCTranslations.class";

'use strict';
// @flow
const angular = require('angular');

export interface Assistant {
  name: string;
}

export default class AssistantsController {
  user: Assistant = {
    name: '',
  };
  errors = {};
  submitted = false;

  translations: SCTranslations = new SCTranslations({
    listTitle: 'LBL_ASSISTANTS',
    // newTitle: 'LBL_NEW_ASSISTANT',
    listIsEmpty: 'LBL_NO_ASSISTANTS_FOUND',
    newTitleNoData: 'LBL_FIRST_NEW_ASSISTANT',
  });

  /*@ngInject*/
  constructor(protected Assistant) {
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/assistants/assistants.controller.ts